import { Box, Button, FormLabel, Stack, TextField } from "@mui/material";
import { ErrorWindow } from "components/ErrorWindow";
import { WarningWindow } from "components/WarningWindow";
import { ReactComponent as RSLogo } from "images/rs-logo.svg";
import { Link } from "react-router-dom";
import { Container, Header } from "../Dashboard.style";
import { Spinner } from "UI/Spinner";
import { GoBack } from "UI/GoBack";
import { useForgotPassword } from "./ForgotPassword.hook";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

export const ForgotPassword = () => {
  const {
    email,
    handleEmailChange,
    emailError,
    handleSubmit,
    error,
    setError,
    loading,
    isSentDialogOpen,
    handleNotificationClose,
    currentYear,
    authBackUrl,
    resendDelay,
  } = useForgotPassword();

  const isDev = process.env.REACT_APP_CURRENT_ENV === "dev";

  return (
    <Container>
      <Header>
        <RSLogo width={"103px"} />
      </Header>
      {!isSentDialogOpen && (
        <div className="flex-1 mb-10 flex flex-col items-center justify-center gap-6">
          <div className="flex flex-col-reverse md:flex-row justify-center items-center gap-2">
            <div className="max-w-96">
              <Box
                component="form"
                onSubmit={(e) => e.preventDefault()}
                noValidate
              >
                <div
                  className={`p-4 sm:p-8 flex flex-col gap-4 rounded-xl border border-solid
                border-gray-300 shadow-lg min-w-72 sm:min-w-80`}
                >
                  <div className="flex flex-col items-start gap-1">
                    <div className="flex flex-row justify-start items-center gap-1">
                      <Link to={authBackUrl}>
                        <GoBack />
                      </Link>
                      <div className="text-2xl font-bold">Reset Password</div>
                    </div>
                  </div>
                  <Stack
                    direction={"row"}
                    alignItems="center"
                    width="100%"
                    gap={2}
                    mb={2}
                  >
                    <Box flex={1}>
                      <FormLabel>
                        Your email
                        <TextField
                          placeholder="Enter your email"
                          required
                          sx={{
                            width: "100%",
                          }}
                          value={email}
                          onChange={handleEmailChange}
                          error={!!emailError}
                          helperText={
                            emailError ? "Please enter a valid email" : ""
                          }
                          inputProps={{
                            type: "email",
                            // pattern: "[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$",
                          }}
                          variant="outlined"
                          autoComplete="username"
                        />
                      </FormLabel>
                    </Box>
                  </Stack>
                  <Button
                    disabled={loading}
                    variant="contained"
                    onClick={handleSubmit}
                  >
                    Send
                  </Button>
                </div>
              </Box>
            </div>
          </div>
          <div className="text-xs sm:text-sm flex flex-row flex-wrap justify-center items-center gap-2">
            Don't have an account?{" "}
            <Link
              to={`https://app${
                isDev ? "-dev" : ""
              }.referral-stream.com/sign_up`}
              target="_blank"
            >
              <span className="text-blue-900">Register</span>
            </Link>
          </div>
        </div>
      )}
      <div className="mb-4 text-gray-500 text-sm flex-grow-0 flex-shrink-0 text-center">
        Copyright © {currentYear} Referral Stream. All rights reserved.
      </div>
      {!error && !loading && isSentDialogOpen && (
        <WarningWindow
          title={null}
          content={
            <div className="flex flex-col items-center gap-4">
              <div className="flex flex-col justify-center items-center gap-1 text-black text-xl font-bold">
                <CheckCircleOutlineIcon fontSize="large" /> Password Reset Link
                Sent
              </div>
              <div className="max-w-96 text-center text-[16px] text-gray-800">
                If you don’t see the email, be sure to check your spam or junk
                folder.
              </div>
              {resendDelay > 0 ? (
                <div className="text-sm text-gray-500">
                  Resend available in 00:00:
                  {resendDelay <= 9 ? `0${resendDelay}` : resendDelay}
                </div>
              ) : (
                <div className="flex flex-row justify-center items-center gap-0 text-sm text-gray-500">
                  Didn't receive the link?
                  <Button
                    variant="text"
                    onClick={handleSubmit}
                    disabled={loading}
                    sx={{
                      padding: "0",
                      fontSize: "0.875rem",
                    }}
                  >
                    Resend
                  </Button>
                </div>
              )}
            </div>
          }
          withCloseButton
          handleClose={handleNotificationClose}
        />
      )}
      {error && <ErrorWindow error={error} handleClose={() => setError("")} />}
      {loading && <Spinner />}
    </Container>
  );
};
